export enum AuthSearchParams {
  LoginFlow = 'loginFlow',
  LoginReason = 'loginReason',
}

export enum SSOParams {
  SSO = 'sso',
  Code = 'code',
}
